//dashboard
// export const URL_GET_LIST_CHECKIN = "/v1/pos/checkin/site/list?"
export const URL_GET_LIST_CHECKIN = "/v1/pos/checkin/site/dash-board-list?"
export const URL_GET_ORDER_DETAIL = "/v1/pos/checkout/site/info?"
export const URL_GET_LIST_ORDER_HISTORY = "/v1/pos/checkout/history/info?"
// export const URL_GET_REPORT_CHECKIN = "/v1/pos/checkin/site/report?"
export const URL_GET_REPORT_CHECKIN = "/v1/pos/checkin/site/dash-board-report?"
export const URL_REMOVE_CHECKIN_ITEM = "/v1/pos/checkout/form/update-status"
export const URL_UPDATE_ORDER_STAFF = "/v1/pos/checkout/form/update-staff"
export const URL_CHECK_PASSWORD = "/v1/user/form/check-password"
export const URL_REMOVE_ORDER = "/v1/pos/checkout/order/remove-order"
export const URL_EXPORT_ORDER = "/v1/pos/checkin/site/export?"
export const URL_CALCULATE_ORDER = "/v1/pos/checkout/order/calculate-order";
export const URL_CHECK_GIFTCARD = "/v1/pos/giftcard/site/check-gift-card";
export const URL_UPDATE_ORDER = "/v1/pos/checkout/order/update-order";
export const URL_RESET_GIFT_CARD = "v1/pos/checkout/item/reset-gift-card";
export const URL_CANCEL_ORDER = "v1/pos/checkout/form/cancelled-order";

//time-keeping
export const URL_GET_LIST_TIME_KEEPING = "/v1/pos/timekeeping/site/list?"
export const URL_ADD_TIME_KEEPING = "/v1/pos/timekeeping/form/create"
export const URL_UPDATE_TIME_KEEPING = "/v1/pos/timekeeping/form/edit-time"
export const URL_REMOVE_TIME_KEEPING = "/v1/pos/timekeeping/form/delete-time"

//payroll
export const URL_GET_PAYROLL_LIST = "v1/pos/payroll/site/list-payroll?"
export const URL_GET_PAYROLL_SETTING = "/v1/pos/setting/site/payroll-setting"
export const URL_APPROVE_PAYROLL = "/v1/pos/payroll/form/approve-payroll"
export const URL_UPDATE_PAYROLL_SETTING = "/v1/pos/setting/form/update-payroll"
export const URL_GET_DISCOUNT_SETTING = "/v1/pos/setting/site/discount-setting"
export const URL_UPDATE_DISCOUNT_SETTING = "/v1/pos/setting/form/update-discount"
export const URL_GET_CASH_DISCOUNT_SETTING = "/v1/pos/cashdiscount/setting/get"
export const URL_UPDATE_CASH_DISCOUNT_SETTING = "/v1/pos/cashdiscount/setting/change"
export const URL_GET_INCOME_DETAIL = "/v1/pos/payroll/staff/income-detail?"
export const URL_GET_APPROVE_PAYROLL = "/v1/pos/payroll/site/approve-period?"
export const URL_EXPORT_PAYROLL = "v1/pos/payroll/site/export-payroll?"
export const URL_EXPORT_APPROVE_PAYROLL = "/v1/pos/payroll/site/export-approve-payroll?"
export const URL_EXPORT_INCOME_DETAIL = "/v1/pos/payroll/staff/export-income-detail?"
export const URL_GET_SALARY_CHART = "/v1/pos/payroll/site/salary-chart?"
export const URL_GET_SALARY_DETAIL = "/v1/pos/payroll/site/get-salary-detail?"

//ticket template
export const URL_GET_TICKET_LIST = '/v1/pos/ticket/site/info?'
export const URL_GET_BLOCK_LIST = '/v1/pos/ticket/site/list-block-name'
export const URL_CREATE_TICKET_TEMPLATE = '/v1/pos/ticket/form/create'
export const URL_DELETE_TICKET_TEMPLATE = '/v1/pos/ticket/form/delete?'
export const URL_UPDATE_TICKET_TEMPLATE = '/v1/pos/ticket/form/update?'
export const URL_MOVE_SUBJECT = '/v1/pos/ticket/form/subject-move?'
export const URL_SET_DEFAULT_TICKET_TEMPLATE = '/v1/pos/ticket/site/set-default-ticket-template'

// batch history
export const URL_GET_BATCH_HISTORY = "/v1/pos/history/site/batch-history?"
export const URL_GET_BATCH_DETAIL = "/v1/pos/history/site/batch-detail?";

// income history
export const URL_GET_INCOME_HISTORY = "/v1/pos/history/site/income-history";

//staff daily income
export const URL_GET_STAFF_DAILY_INCOME = "/v1/pos/staff/site/list-income-v1";